// extracted by mini-css-extract-plugin
export default {"wrapper":"CC-z","button":"DC-z","alternate":"EC-z","disabled":"FC-z","paymentWarning":"GC-z","fadeIn":"HC-z"};